/* CARLA HOME — bloques comparativos del blog.
   - [data-handle] en la cabecera de .ch-art-cmp y en .ch-art-pcard: foto, precio y stock en vivo
     desde /products/<handle>.js (el post nunca enseña un precio desfasado).
   - .ch-art-cmp: genera tarjetas por producto para móvil (el CSS decide cuándo se ven). */
(function () {
  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function img(p, size) {
    if (!p.featured_image) return null;
    var el = document.createElement('img');
    var src = p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image;
    el.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + size * 2 + '&height=' + size * 2 + '&crop=center';
    el.alt = p.title;
    el.width = size;
    el.height = size;
    el.loading = 'lazy';
    return el;
  }
  function buy(p) {
    var wrap = document.createElement('span');
    wrap.className = 'ch-art-buy';
    var price = document.createElement('b');
    price.textContent = money(p.price);
    wrap.appendChild(price);
    if (p.available) {
      var a = document.createElement('a');
      a.href = p.url;
      a.textContent = 'Shop →';
      wrap.appendChild(a);
    } else {
      var s = document.createElement('span');
      s.className = 'ch-art-soldout';
      s.textContent = 'Sold out';
      wrap.appendChild(s);
    }
    return wrap;
  }
  function link(p, child) {
    var a = document.createElement('a');
    a.href = p.url;
    a.appendChild(child);
    return a;
  }

  function initCard(card) {
    getProduct(card.dataset.handle).then(function (p) {
      if (!p) return;
      var note = card.querySelector('p');
      card.textContent = '';
      var pic = img(p, 120);
      if (pic) card.appendChild(link(p, pic));
      var body = document.createElement('div');
      var name = document.createElement('p');
      name.className = 'ch-art-pcard-name';
      name.appendChild(link(p, document.createTextNode(p.title)));
      body.appendChild(name);
      if (note) body.appendChild(note);
      body.appendChild(buy(p));
      card.appendChild(body);
    });
  }

  function initTable(box) {
    var table = box.querySelector('table');
    if (!table) return;
    if (!box.querySelector('.ch-art-cmp-scroll')) {
      var scroll = document.createElement('div');
      scroll.className = 'ch-art-cmp-scroll';
      table.parentNode.insertBefore(scroll, table);
      scroll.appendChild(table);
    }
    var heads = Array.prototype.slice.call(table.querySelectorAll('thead th')).slice(1);
    var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));
    var cards = document.createElement('div');
    cards.className = 'ch-art-cmp-cards';
    var jobs = heads.map(function (th, i) {
      var card = document.createElement('div');
      card.className = 'ch-art-ccard';
      var head = document.createElement('div');
      head.className = 'ch-art-ccard-head';
      var name = document.createElement('strong');
      name.textContent = th.textContent.trim();
      var info = document.createElement('div');
      info.appendChild(name);
      head.appendChild(info);
      card.appendChild(head);
      var dl = document.createElement('dl');
      rows.forEach(function (tr) {
        var label = tr.querySelector('th');
        var cell = tr.querySelectorAll('td')[i];
        if (!label || !cell) return;
        var dt = document.createElement('dt');
        dt.textContent = label.textContent.trim();
        var dd = document.createElement('dd');
        dd.textContent = cell.textContent.trim();
        dl.appendChild(dt);
        dl.appendChild(dd);
      });
      card.appendChild(dl);
      cards.appendChild(card);
      if (!th.dataset.handle) return null;
      return getProduct(th.dataset.handle).then(function (p) {
        if (!p) return;
        var big = img(p, 88);
        if (big) { big.className = 'ch-art-cmp-img'; th.insertBefore(link(p, big), th.firstChild); }
        th.appendChild(buy(p));
        var small = img(p, 64);
        if (small) head.insertBefore(link(p, small), info);
        info.appendChild(buy(p));
      });
    });
    box.appendChild(cards);
    box.classList.add('has-cards');
    return Promise.all(jobs);
  }

  function init() {
    document.querySelectorAll('.ch-art-cmp').forEach(initTable);
    document.querySelectorAll('.ch-art-pcard[data-handle]').forEach(initCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
